import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import AboutUs_Section1 from "./sections/AboutUs_Section1";
import AboutUs_Section2 from "./sections/AboutUs_Section2";
import AboutUs_Section3 from "./sections/AboutUs_Section3";

function AboutUs() {
  usePageMeta({
    title: "About Us | Spechs Ireland",
    description:
      "Learn about Spechs — our story, our team, and our commitment to quality cleaning, property management, and workforce solutions across Ireland.",
    canonical: "https://www.spechs.ie/about-us/",
  });
  return (
    <SubPageLayout title="About Us">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <AboutUs_Section1 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <AboutUs_Section2 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <AboutUs_Section3 />
      </MKBox>
    </SubPageLayout>
  );
}

export default AboutUs;
